import styled from 'styled-components'
import { colors } from 'app/theme/colors'

export const ProgramCardContainer = styled.div`
  background-color: #ffe1d9;
  width: 240px;
  height: 240px;
  border: solid 1px ${colors.ohOrange};
  border-radius: 8px;
  cursor: pointer;

  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;

  justify-content: center;
  align-items: center;
`

export const CardIcon = styled.img`
  height: 48px;
  width: 48px;
  border-radius: 8px;
`

export const Footer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 8px;

  color: ${colors.ohWhite};
  text-align: center;
  background-color: ${colors.ohOrange};
  font-size: 12px;
  font-weight: 600;
`

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const ProgramName = styled.div`
  margin-top: 4px;
  font-size: 16px;
  font-weight: 600;
`

export const ProgramTimings = styled.div`
  margin-top: 6px;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  max-width: 208px;
  line-height: 1.35;
  word-break: break-word;
`

export const EnrolLink = styled.div`
  color: ${colors.ohOrange};
  font-size: 12px;

  position: absolute;
  top: 12px;
  right: 12px;

  display: flex;
  flex-direction: row;
  align-items: center;
`

export const EnrolText = styled.span`
  text-decoration: underline;
`
